export enum Key {
  Backspace = 8,
  Tab = 9,
  Enter = 13,
  Shift = 16,
  Escape = 27,
  Space = 32,

  LeftArrow = 37,
  UpArrow = 38,
  RightArrow = 39,
  DownArrow = 40,

  Insert = 45,
  Delete = 46,

  A = 65,
  B = 66,
  C = 67,
  D = 68,
  E = 69,
  F = 70,
  G = 71,
  H = 72,
  I = 73,
  J = 74,
  K = 75,
  L = 76,
  M = 77,
  N = 78,
  O = 79,
  P = 80,
  Q = 81,
  R = 82,
  S = 83,
  T = 84,
  U = 85,
  V = 86,
  W = 87,
  X = 88,
  Y = 89,
  Z = 90,

  SemiColon = 186,
  Equals = 187,
  Comma = 188,
  Period = 190,
  Plus = Equals,
  Minus = 189,
  ForwardSlash = 191,
  Tilde = 192,
  GraveAccent = Tilde,
  OpenBracket = 219,
  ClosedBracket = 221,

  Digit7 = 55,
  Digit8 = 56,
}

export enum Code {
  Enter = 'Enter',
  Escape = 'Escape',
  ArrowDown = 'ArrowDown',
  ArrowUp = 'ArrowUp',
  Tab = 'Tab',
  Space = ' ',
  Backspace = 'Backspace',
  Delete = 'Delete',
  Meta = 'Meta',
  Alt = 'Alt',
  Shift = 'Shift',
  Control = 'Control',
  ArrowRight = 'ArrowRight',
  ArrowLeft = 'ArrowLeft',
  Home = 'Home',
  End = 'End',
  T = 'KeyT',
  B = 'KeyB',
  I = 'KeyI',
  U = 'KeyU',
}

export enum TagName {
  Button = 'BUTTON',
}

export enum Step {
  Small = 1,
  Medium = 10,
  Large = 15,
}
